import { cloneDeep } from "lodash";
import { SkillsFramework, SkillsFrameworkRank } from "PFTypes/skills_framework";
import { useMemo } from "react";

import { useSkillsFrameworksTab } from "../../list/hooks/use_skills_frameworks_tab";
import { SkillsFrameworkData } from "../../skills_frameworks.types";
import { getFormattedSkillsFramework } from "../../utils";

type UseInitialValues = {
  isNew: boolean;
  skillsFramework: SkillsFramework | null;
};

const emptyInitialValues: SkillsFrameworkData = {
  id: 0,
  name: "",
  description: "",
  customFields: [],
  skills: {
    essential: [],
    supporting: []
  },
  rank: SkillsFrameworkRank.Primary
};

export const useInitialValues = ({ isNew, skillsFramework }: UseInitialValues): SkillsFrameworkData => {
  const { activeTab } = useSkillsFrameworksTab();

  return useMemo(() => {
    let initialValues: SkillsFrameworkData = { ...emptyInitialValues, rank: activeTab };
    if (!isNew && skillsFramework) {
      initialValues = getFormattedSkillsFramework(skillsFramework);
    }

    return cloneDeep(initialValues);
  }, [isNew, skillsFramework]);
};
